<template>
  <SimpleQuillEditor
    ref="editor"
    :title="title"
    :show-byline="false"
    :tile-view="tileView"
    :content="content"
    @save="save"
  ></SimpleQuillEditor>
</template>

<script setup lang="ts">
import { ref, onMounted, useTemplateRef } from "vue"

import SimpleQuillEditor from "@/components/common/SimpleQuillEditor.vue"
import CorpApi from "@/apis/corpApi"

const api = new CorpApi()

const props = defineProps({
  title: { type: String },
  tileView: { type: Boolean, default: false },
  remoteKey: { type: String, required: true },
  resourcePath: { type: String, required: true }
})

const editorRef = useTemplateRef<InstanceType<typeof SimpleQuillEditor>>("editor")

//eslint-disable-next-line @typescript-eslint/no-explicit-any
const content = ref<{ ops: any[] }>()

onMounted(async () => {
  const docPath = `${props.resourcePath}?path=${props.remoteKey}`
  try {
    const doc = await api.loadCorpDoc(docPath)
    content.value = doc
  } catch {
    console.warn("unable to load the doc from remote when model is initialized ")
    content.value = { ops: [] }
  }
})

//eslint-disable-next-line @typescript-eslint/no-explicit-any
async function save(newContent: any) {
  const status = await api.saveCorpDoc(props.resourcePath, props.remoteKey, newContent)
  content.value = newContent
  editorRef.value?.showSnack(status === 200 ? "success" : "error")
}
</script>
